import React, { PureComponent } from "react";
import Template from "../components/Template";
import Navbar from "../components/Navbar";
import Modal from "../components/helpers/Modal";
import SwalToast from "../components/helpers/SwalToast";
import Config from "../components/axios/Config";
import $ from "jquery";
import axios from "axios";
import Cookie from "js-cookie";
import IsEmpty from "../components/helpers/IsEmpty";

class GlobalSetting extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isEditMode: false,
      name: "",
      old_name: "",
      error_name: "",
    };
    this.save = this.save.bind(this);
  }

  save() {
    if (this.state.name == "") {
      this.setState({ error_name: "The name field is required." });
    } else {
      axios
        .put(
          `${process.env.REACT_APP_BASE_API_URL}globalConfig/1`,
          {
            value: this.state.name,
          },
          Config({
            Authorization: `Bearer ${Cookie.get("token")}`,
          })
        )
        .then((response) => {
          this.getData();
          this.setState(
            {
              isEditMode: false,
              name: "",
            },
            () => {
              SwalToast.fire({
                icon: "success",
                title: "Successfully changed!",
              });
            }
          );
        })
        .catch((error) => {
          SwalToast.fire({
            icon: "error",
            title: error.response
              ? error.response.data.message
              : "Whoops, something went wrong!",
          });
        });
    }
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    axios
      .get(
        `${process.env.REACT_APP_BASE_API_URL}globalConfig`,
        Config({
          Authorization: `Bearer ${Cookie.get("token")}`,
        })
      )
      .then((response) => {
        this.setState({
          old_name: response.data.data[0].value,
        });
      })
      .catch((error) => {
        SwalToast.fire({
          icon: "error",
          title: "Whoops, something went wrong!",
        });
      });
  }

  render() {
    return (
      <Template>
        <Navbar>
          <h4 className="m-0 color-374650 font-weight-bold">Global Setting</h4>
        </Navbar>
        <div className="p-3">
          <Modal
            modalId={"change-password-confirmation"}
            title={"Are you sure?"}
          >
            <div className="text-center mt-2">
              <i className="fas fa-question color-0F74BD fa-9x"></i>
            </div>
            <div className="mt-4 row no-gutters">
              <div className="col-6 pr-2">
                <button
                  className="btn btn-block color-95A4AF border-95A4AF hover-95A4AF"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
              <div className="col-6 pl-2">
                <button
                  onClick={this.save}
                  className="btn btn-block text-white bgc-0F74BD shadow-graph"
                >
                  Okay
                </button>
              </div>
            </div>
          </Modal>
          <div className="">
            <div className="mt-3 d-flex align-items-center">
              <p className="m-0 color-22262A font-weight-semi-bold">
                President Name:
              </p>
              <p className="mb-0 ml-5 color-22262A font-weight-semi-bold">
                {this.state.old_name}
              </p>
              {!this.state.isEditMode && (
                <a
                  href="javascript:void(0)"
                  className="ml-5 color-2E90E5 small"
                  onClick={(event) =>
                    this.setState({
                      isEditMode: true,
                    })
                  }
                >
                  Change
                </a>
              )}
            </div>
            {this.state.isEditMode && (
              <div className="row mt-3">
                <div className="col-6">
                  <div className="form-group">
                    <label
                      htmlFor="old-password-field"
                      className="color-374650"
                    >
                      New Name
                    </label>
                    <input
                      type="name"
                      className="form-control"
                      id="name"
                      placeholder="Name"
                      value={this.state.name}
                      onChange={(event) =>
                        this.setState({
                          name: event.target.value,
                        })
                      }
                    />
                    {this.state.error_name !== "" && (
                      <div
                        className="alert alert-danger py-2 mt-2"
                        role="alert"
                      >
                        {this.state.error_name}
                      </div>
                    )}
                  </div>

                  <div className="d-flex justify-content-between">
                    <button
                      className="btn border-EB2424 shadow-graph color-EB2424 font-weight-bold"
                      onClick={(event) =>
                        this.setState({
                          isEditMode: false,
                          old_password: "",
                          new_password: "",
                          confirm_password: "",
                          error_message: {
                            old_password: "",
                            new_password: "",
                            confirm_password: "",
                          },
                        })
                      }
                    >
                      Cancel
                    </button>
                    <button
                      className="btn bgc-374650 shadow-graph text-white font-weight-bold"
                      disabled={this.state.action_button_disabled}
                      onClick={this.save}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </Template>
    );
  }
}

export default GlobalSetting;
